module.exports = __webpack_public_path__ + "img/charity-4.846705fb.png";